import { createRouter, createWebHistory } from 'vue-router';
import Home from '@/pages/Home';

export default createRouter({
  history: createWebHistory(),
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/ticket-history',
      name: 'TerminalTicketHistory',
      component: () =>
        import(
          /* webpackChunkName: "TerminalTicketHistory" */ '@/layouts/TerminalTicketHistory'
        ),
    },
    {
      path: '/results',
      name: 'TerminalResults',
      component: () =>
        import(
          /* webpackChunkName: "TerminalResults" */ '@/layouts/TerminalResults'
        ),
    },
  ],
});
